export default {
  badge: 'Odznaka',
  open: 'Otwórz',
  close: 'Zamknij',
  dismiss: 'Odrzuć',
  confirmEdit: {
    ok: 'OK',
    cancel: 'Anuluj',
  },
  dataIterator: {
    noResultsText: 'Nie znaleziono danych odpowiadających wyszukiwaniu',
    loadingText: 'Wczytywanie danych...',
  },
  dataTable: {
    itemsPerPageText: 'Wierszy na stronie:',
    ariaLabel: {
      sortDescending: 'Sortowanie malejąco. Kliknij aby zmienić.',
      sortAscending: 'Sortowanie rosnąco. Kliknij aby zmienić.',
      sortNone: 'Bez sortowania. Kliknij aby posortować rosnąco.',
      activateNone: 'Kliknij aby usunąć sortowanie.',
      activateDescending: 'Kliknij aby posortować malejąco.',
      activateAscending: 'Kliknij aby posortować rosnąco.',
      selectRow: 'Wybierz wiersz',
      selectAll: 'Wybierz wszystkie',
      selectGroup: 'Wybierz grupę',
    },
    sortBy: 'Sortuj według',
  },
  dataFooter: {
    itemsPerPageText: 'Pozycji na stronie:',
    itemsPerPageAll: 'Wszystkie',
    nextPage: 'Następna strona',
    prevPage: 'Poprzednia strona',
    firstPage: 'Pierwsza strona',
    lastPage: 'Ostatnia strona',
    pageText: '{0}-{1} z {2}',
  },
  dateRangeInput: {
    divider: 'do',
  },
  monthPicker: {
    title: 'Wybierz miesiąc',
    itemsSelected: '{0} wybrano',
    header: 'Wprowadź miesiąc',
    range: {
      title: 'Wprowadź miesiące',
    },
    ariaLabel: {
      previousYear: 'Poprzedni rok',
      nextYear: 'Następny rok',
      selectYear: 'Wybierz rok',
      currentMonth: 'Bieżący miesiąc, {0}',
    },
  },
  datePicker: {
    itemsSelected: '{0} wybrano',
    range: {
      title: 'Wybór zakresu dat',
      header: 'Wprowadź zakres dat',
    },
    title: 'Wybór daty',
    header: 'Wprowadź datę',
    input: {
      placeholder: 'Wprowadź datę',
    },
    ariaLabel: {
      previousMonth: 'Poprzedni miesiąc',
      nextMonth: 'Następny miesiąc',
      selectYear: 'Wybierz rok',
      previousYear: 'Poprzedni rok',
      nextYear: 'Następny rok',
      selectMonth: 'Wybierz miesiąc',
      selectDate: '{0}',
      currentDate: 'Dzisiaj, {0}',
    },
  },
  noDataText: 'Brak danych',
  carousel: {
    prev: 'Poprzedni obraz',
    next: 'Następny obraz',
    ariaLabel: {
      delimiter: 'Obraz {0} z {1}',
    },
  },
  calendar: {
    moreEvents: '{0} więcej',
    today: 'Dzisiaj',
  },
  heatmap: {
    less: 'Mniej',
    more: 'Więcej',
  },
  input: {
    clear: 'Wyczyść {0}',
    prependAction: '{0} dodatkowa akcja',
    appendAction: '{0} dodatkowa akcja',
    otp: 'Wprowadź kod weryfikacyjny',
  },
  fileInput: {
    counter: 'Liczba plików: {0}',
    counterSize: 'Liczba plików: {0} (łącznie {1})',
  },
  fileUpload: {
    title: 'Przeciągnij i upuść pliki tutaj',
    divider: 'lub',
    browse: 'Przeglądaj pliki',
  },
  timePicker: {
    am: 'AM',
    pm: 'PM',
    title: 'Wybierz godzinę',
    hour: 'Godzina',
    minute: 'Minuty',
    second: 'Sekudy',
    notAllowed: 'Wartość jest niedozwolona',
  },
  pagination: {
    ariaLabel: {
      root: 'Nawigacja paginacyjna',
      next: 'Następna strona',
      previous: 'Poprzednia strona',
      page: 'Idź do strony {0}',
      currentPage: 'Bieżąca strona, strona {0}',
      first: 'Pierwsza strona',
      last: 'Ostatnia strona',
    },
  },
  stepper: {
    next: 'Następny',
    prev: 'Poprzedni',
  },
  rating: {
    ariaLabel: {
      item: 'Ocena {0} na {1}',
    },
  },
  loading: 'Wczytywanie danych...',
  infiniteScroll: {
    loadMore: 'Wczytaj więcej',
    empty: 'Brak kolejnych danych',
  },
  rules: {
    required: 'To pole jest wymagane',
    email: 'Proszę podać prawidłowy adres e-mail',
    number: 'To pole może zawierać tylko cyfry',
    integer: 'To pole może zawierać tylko liczby całkowite',
    capital: 'To pole może zawierać tylko wielkie litery',
    maxLength: 'Musisz wprowadzić maksymalnie {0} znaków',
    minLength: 'Musisz wprowadzić co najmniej {0} znaków',
    strictLength: 'Długość wprowadzonego pola jest nieprawidłowa',
    exclude: 'Znak {0} nie jest dozwolony',
    notEmpty: 'Proszę wybrać co najmniej jedną wartość',
    pattern: 'Nieprawidłowy format',
  },
  command: {
    search: 'Wpisz polecenie lub szukaj...',
  },
  hotkey: {
    then: 'następnie',
    ctrl: 'Ctrl',
    command: 'Command',
    shift: 'Shift',
    alt: 'Alt',
    option: 'Option',
    enter: 'Enter',
    escape: 'Escape',
    upArrow: 'Strzałka w górę',
    downArrow: 'Strzałka w dół',
    leftArrow: 'Strzałka w lewo',
    rightArrow: 'Strzałka w prawo',
    backspace: 'Backspace',
    space: 'Spacja',
    plus: 'plus',
    shortcut: 'Skrót klawiszowy: {0}',
    or: 'lub',
  },
  video: {
    play: 'Odtwórz',
    pause: 'Wstrzymaj',
    seek: 'Przewiń',
    volume: 'Głośność',
    showVolume: 'Pokaż regulację głośności',
    mute: 'Wycisz',
    unmute: 'Wyłącz wyciszenie',
    enterFullscreen: 'Pełny ekran',
    exitFullscreen: 'Opuść pełny ekran',
  },
  colorPicker: {
    ariaLabel: {
      eyedropper: 'Pobierz kolor z ekranu',
      hueSlider: 'Odcień',
      alphaSlider: 'Przezroczystość',
      redInput: 'Czerwony',
      greenInput: 'Zielony',
      blueInput: 'Niebieski',
      alphaInput: 'Przezroczystość',
      hueInput: 'Odcień',
      saturationInput: 'Nasycenie',
      lightnessInput: 'Jasność',
      hexInput: 'Wartość szesnastkowa',
      hexaInput: 'Wartość szesnastkowa z kanałem alfa',
      changeFormat: 'Zmień format koloru',
    },
  },
}
